import * as types from "../../actions/ActionTypes";

const initialState = {
  loading: false,
  data:    null,
  error:   null,
};

const businessUpgradeRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.POST_BUSINESS_UPGRADE_REQUEST_START:
      return { ...state, loading: true, error: null };

    case types.POST_BUSINESS_UPGRADE_REQUEST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };

    case types.POST_BUSINESS_UPGRADE_REQUEST_ERROR:
      return { ...state, loading: false, error: action.payload };

    case types.POST_BUSINESS_UPGRADE_REQUEST_RESET:
    case types.LOGOUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default businessUpgradeRequestReducer;
